var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      class: _vm.customClass,
      attrs: { disabled: _vm.isDisabled },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.makeOutboundCall.apply(null, arguments)
        },
      },
    },
    [
      _vm._t("default", function () {
        return [_c("i", { staticClass: "fas fa-phone-alt" })]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }